import { FetchModelResponse } from '@cian/http-api';

import { IErrorResponseSchema } from 'shared/repositories/offers-comparison/entities/schemas/ErrorResponseSchema';

export const mapAddOfferToComparisonResponseError = (
  response: IErrorResponseSchema,
): FetchModelResponse<400, 'json', IErrorResponseSchema> => {
  return {
    statusCode: 400,
    response: {
      errors: response.errors,
      message: response.message,
    },
  };
};
